import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

export default (action, params) => {
  const dispatch = useDispatch();
  useEffect(() => {
    params ? dispatch(action(params)) : dispatch(action());
  }, [action, dispatch, params]);
};
